module.exports = __webpack_public_path__ + "img/9791158881481.5500776f.jpg";